import {
  KeepLearningCardCourse
} from "./KeepLearningCard.types";
import { LEVEL, STATUS_LO } from "../../consts";

/* eslint-disable max-len */
export const Default: {courses: KeepLearningCardCourse[]} = {
  courses: [
    { 
      categories: [],
      coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
      id: 1,
      learningObjectTypology: LEVEL.DA_EXTERNAL_RES,
      percentageOfCompletion: "20%",
      status: STATUS_LO.E,
      title: "FY2023 - 1"
    },
    { 
      categories: ["blockchain"],
      coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
      id: 3,
      learningObjectTypology: LEVEL.DA_VIRTUAL_CLASS,
      percentageOfCompletion: "80%",
      status: STATUS_LO.N,
      title: "FY2023 - 2"
    },
    { 
      categories: ["tecnologia"],
      coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
      id: 5,
      learningObjectTypology: LEVEL.DA_SCORM,
      percentageOfCompletion: "80%",
      status: STATUS_LO.P,
      title: "FY2023 - 3"
    }
    // { 
    //   categories: ["finanza"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.2,
    //   title: "FY2023 - 1"
    // },
    // { 
    //   categories: ["blockchain"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.8,
    //   title: "FY2023 - 2"
    // },
    // { 
    //   categories: ["tecnologia"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.8,
    //   title: "FY2023 - 3"
    // },
    // { 
    //   categories: ["finanza"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.2,
    //   title: "FY2023 - 1"
    // },
    // { 
    //   categories: ["blockchain"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.8,
    //   title: "FY2023 - 2"
    // },
    // { 
    //   categories: ["tecnologia"],
    //   id: 1,
    //   coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
    //   level: LEVEL.PATH,
    //   progress: 0.8,
    //   title: "FY2023 - 3"
    // }
  ]
  
};

export const noCourses = {
  courses: []
  
};
/* eslint-enable max-len */
